/* LYTES purchase options (one-time vs Auto Delivery).
   Works with snippets/lytes-purchase-options.liquid (see mount() below for how it gets
   into the product form).
   The theme submits the product form with $.serializeArray() from a jQuery submit
   handler. Seal Subscriptions' script deletes any selling_plan input it finds in the
   form, so we keep the chosen plan on the selector (data-ly-plan) and only add the
   selling_plan input at submit time, in a capture-phase listener that runs before the
   theme's handler. Uses delegated listeners throughout. */
(function () {
  'use strict';
  if (window.__lytesRefresh) return; // loaded by more than one snippet on the product page
  window.__lytesRefresh = true;

  function money(cents) {
    var format = (window.Theme && window.Theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]*>/g, '');
  }

  function readData(po) {
    if (po._lyData) return po._lyData;
    var el = po.querySelector('[data-ly-po-data]');
    try { po._lyData = JSON.parse(el.textContent); } catch (e) { po._lyData = null; }
    return po._lyData;
  }

  function update(po) {
    var form = po.closest('form');
    var data = readData(po);
    if (!form || !data) return;

    var autoRadio = po.querySelector('input[data-ly-po-mode="auto"]');
    var isAuto = !!(autoRadio && autoRadio.checked);
    var activeFreq = po.querySelector('[data-ly-po-freqs] button[aria-pressed="true"]');
    var planId = activeFreq ? activeFreq.getAttribute('data-plan') : data.defaultPlan;
    po.setAttribute('data-ly-plan', isAuto && planId ? planId : '');

    Array.prototype.forEach.call(po.querySelectorAll('.ly-po__opt'), function (opt) {
      var radio = opt.querySelector('.ly-po__radio');
      opt.classList.toggle('is-active', !!(radio && radio.checked));
    });

    var idEl = form.querySelector('[name="id"]');
    var variant = (idEl && data.variants[idEl.value]) || data.variants[data.first];
    if (!variant) return;

    var autoPrice = (variant.plans && variant.plans[planId]) || variant.price;
    var set = function (sel, text) { var n = po.querySelector(sel); if (n) n.textContent = text; };
    set('[data-ly-po-one]', money(variant.price));
    set('[data-ly-po-one-was]', variant.compare > variant.price ? money(variant.compare) : '');
    set('[data-ly-po-auto]', money(autoPrice));
    set('[data-ly-po-auto-was]', money(Math.max(variant.price, variant.compare || 0)));
    if (data.serves > 1) {
      set('[data-ly-po-one-pps]', money(Math.round(variant.price / data.serves)) + ' / serve');
      set('[data-ly-po-auto-pps]', money(Math.round(autoPrice / data.serves)) + ' / serve');
    }
  }

  /* Seal Subscriptions' app embed injects its own widget (.sealsubs-container) on the
     product page. Where our selector is mounted, remove Seal's widget so only one set of
     purchase options shows. */
  function removeSeal(po) {
    var scope = po.closest('[data-product-details]') || po.closest('.product-details') || po.closest('form');
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('.sealsubs-container, .sealsubs-target-element'), function (el) {
      if (!el.contains(po)) el.parentNode.removeChild(el);
    });
  }

  /* At submit, before the theme serialises the form: drop any selling_plan input (Seal's)
     and, if Auto Delivery is chosen, add ours with the selected plan. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var po = form.querySelector('[data-ly-po]');
    if (!po) return;
    update(po);
    Array.prototype.forEach.call(form.querySelectorAll('input[name="selling_plan"]'), function (input) {
      input.parentNode.removeChild(input);
    });
    var plan = po.getAttribute('data-ly-plan');
    if (plan) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = plan;
      form.appendChild(input);
    }
  }, true);

  /* The selector is rendered by a custom-liquid block directly above the theme's form
     block (so no core theme file is edited). Move it inside the product form, just
     before quantity + add to cart, so its selling_plan input is submitted with it. */
  function mount(po) {
    if (po.closest('form')) return;
    var details = po.closest('[data-product-details]') || po.closest('.product-details') || document;
    var form = details.querySelector('form[data-product-form]');
    if (!form) return;
    var atc = form.querySelector('.product-form--atc');
    form.insertBefore(po, atc || null);
    var block = details.querySelector('.product-block [data-ly-po-slot]');
    if (block) block.closest('.product-block').style.display = 'none';
  }

  /* The "Top 10% most popular" badge is rendered with the product highlights but belongs on
     the main product image (top left). Move it into the theme's gallery container. */
  function moveBadges() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ly-pop]'), function (badge) {
      if (badge.closest('.product-gallery')) return;
      var outer = badge.closest('.product--outer');
      var gallery = outer && outer.querySelector('.product-gallery');
      if (!gallery) return;
      gallery.appendChild(badge);
      badge.classList.add('is-mounted');
    });
  }

  function updateAll() {
    moveBadges();
    Array.prototype.forEach.call(document.querySelectorAll('[data-ly-po]'), function (po) {
      mount(po);
      removeSeal(po);
      update(po);
    });
  }

  function later() { window.setTimeout(updateAll, 60); }

  document.addEventListener('click', function (event) {
    var freq = event.target.closest && event.target.closest('[data-ly-po-freqs] button');
    if (freq) {
      event.preventDefault();
      var po = freq.closest('[data-ly-po]');
      Array.prototype.forEach.call(freq.parentNode.querySelectorAll('button'), function (b) {
        b.setAttribute('aria-pressed', b === freq ? 'true' : 'false');
      });
      var auto = po.querySelector('input[data-ly-po-mode="auto"]');
      if (auto) auto.checked = true;
      update(po);
      return;
    }
    if (event.target.closest && event.target.closest('form [data-product-option], form .options-selection')) {
      later();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('form')) later();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  /* Quick shop injects product HTML after load: refresh any new selector that appears. */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches('[data-ly-po], .sealsubs-container') || node.querySelector('[data-ly-po], .sealsubs-container'))) {
            pending = true;
            window.setTimeout(function () { pending = false; updateAll(); }, 60);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();